export default "__VITE_ASSET__C27FJBiK__"